export const OFFER = {
  pct: 40,
  deadline: new Date("2026-12-31T23:59:59"),
  deadlineLabel: "31 dicembre 2026",
  short: "Offerta lancio −40%",
};

export const offerActive = () => new Date() <= OFFER.deadline;

export const discounted = (price) =>
  offerActive() ? Math.round((price * (1 - OFFER.pct / 100)) / 10) * 10 : price;

export const eur = (v) => `€${v.toLocaleString("it-IT")}`;
